/* es5-ext/string/#/contains/index */ function _(require, module, exports) {
    module.exports = require(361) /* ./is-implemented */()
        ? String.prototype.contains
        : require(362) /* ./shim */;
}
